import { render, staticRenderFns } from "./CustomLinkProperties.vue?vue&type=template&id=82927aa8&scoped=true"
import script from "./CustomLinkProperties.vue?vue&type=script&lang=js"
export * from "./CustomLinkProperties.vue?vue&type=script&lang=js"
import style0 from "./CustomLinkProperties.vue?vue&type=style&index=0&id=82927aa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82927aa8",
  null
  
)

export default component.exports